
const state = {
}
const actions = {

}

const mutations = {

}

const getters = {

}
export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/baseState.js